import { createFileRoute } from '@tanstack/react-router'
import { ProfileSettingsPage } from '../../../components/Settings/ProfileSettingsPage'
import { useAutoSaveSettings } from '../../../components/Settings/useAutoSaveSettings'
import TimeCapacityForm from '../../../screens/onboarding/forms/TimeCapacityForm'

export const Route = createFileRoute('/_authenticated/settings/week')({
  component: WeekSettings,
})

function WeekSettings() {
  const { save, retry, status } = useAutoSaveSettings()

  return (
    <ProfileSettingsPage
      title="Your week"
      description="So we never suggest something your week can't hold."
      saveStatus={status}
      onRetry={retry}
    >
      <TimeCapacityForm onSubmit={(timeCapacity) => save({ timeCapacity })} autoSave />
    </ProfileSettingsPage>
  )
}
